import { useEffect, useState} from 'react';
import { connect, useDispatch } from 'react-redux';
import Title from "../commons/header_title";
import colores from "../../shared/constants/styles";
import { requestClienteContact } from '../../actions/cliente';
import { Alert, FormControl, Stack, TextField, CircularProgress } from '@mui/material';
import Dolar from '../../routes/dolar';

const ContactForm = (props: any) => {
    const localStorage = window.localStorage.getItem("LocalSession") 
                        ? JSON.parse(window.localStorage.getItem("LocalSession") as string)
                        : null;
    
    const dispatch = useDispatch()    
    const [loading, setLoading] = useState<boolean>(false);
    const [contacto, setContacto] = useState({
        Email: localStorage.email,
        Issue: "",
        Message: "",
        ClienteId: localStorage.clienteId,
        RazonSocial: localStorage.bussinessName,
        Telefono: localStorage.telefono
    })

    const [errors, setErrors] = useState({
        Issue: "",
        Message: ""
    });

    const handleAsuntoToChange = (event: any) => {
        setContacto({
            ...contacto,
            Issue: event.target.value
        });
    };

    const handleMensajeToChange = (event: any) => {
        setContacto({
            ...contacto,
            Message: event.target.value
        });
    };
    
    const handleEnviar= () => {
        if (validateForm()) {
            setLoading(true);
            dispatch(requestClienteContact(contacto));
        }
    }

    const validateForm = () => {
        let isValid = true;
        const newErrors = { Issue: "", Message: "" };
    
        if (!contacto.Issue.trim()) {
            newErrors.Issue = "Ingrese un asunto.";
            isValid = false;
        }
    
        if (!contacto.Message.trim()) {
            newErrors.Message = "Ingrese su mensaje.";
            isValid = false;
        }
    
        setErrors(newErrors);
        return isValid;
    };

    useEffect(() => {
        if(props.success){
            setLoading(false);
            setContacto({
                Email: localStorage.email,
                Issue: "",
                Message: "",
                ClienteId: localStorage.clienteId,
                RazonSocial: localStorage.bussinessName,
                Telefono: localStorage.telefono
            })
        }
    }, [props])

    return (
        <>
        <div
            style={{
            backgroundColor: colores.grisClaro,
            overflow: "hidden",
            clear: "both",
            }}
        >
            <div>
                <Dolar></Dolar> 
                <Title title={"CONTACTO"}></Title>
            </div>
            <div
                className="container-fluid"
                style={{
                    backgroundColor: "white",
                    width: "100%",
                    overflow: "hidden",
                    clear: "both",
                    marginBottom: "1.85rem",
                    paddingLeft: "76px",
                    paddingRight: "76px",
                }}
            >
                <div className='d-grid gap-2 col-12 col-md-5 mx-auto' style={{paddingTop:"2rem", paddingBottom:"4rem"}}>
                        <FormControl fullWidth error={!!errors.Issue}>
                            <TextField
                                id="asunto"
                                name="Asunto"
                                onChange={handleAsuntoToChange}
                                label="Asunto *"
                                value={contacto.Issue}
                                error={!!errors.Issue}
                                helperText={errors.Issue}
                            />
                        </FormControl>
                        <FormControl fullWidth error={!!errors.Message}>
                            <TextField
                                id="mensaje"
                                name="Mensaje"
                                onChange={handleMensajeToChange}
                                label="Mensaje *"
                                multiline
                                rows={4}
                                value={contacto.Message}
                                error={!!errors.Message}
                                helperText={errors.Message}
                            />
                        </FormControl>
                    <div className='d-inline'>
                        <div>
                            <button 
                                className="btn d-flex align-items-center justify-content-center"
                                type="submit" 
                                style={{
                                    width: '16.875rem',
                                    height: '2.813rem',
                                    background: colores.rojo,
                                    color: 'white',
                                    position: 'relative',
                                    opacity: props.loading ? 0.7 : 1,
                                    pointerEvents: props.loading ? 'none' : 'auto'
                                }}
                                onClick={handleEnviar}
                            >
                                {loading ? (
                                    <CircularProgress size={24} sx={{ color: 'white' }} />
                                ) : (
                                    'Confirmar'
                                )}
                            </button>
                        </div>
                    </div>
                    { 
                        (props.success) && 
                        <Stack sx={{ width: '33.688rem', marginTop: '60px'}} spacing={2}>
                            <Alert severity="success">Su mensaje fue enviado correctamente. Su vendedor se contactará.</Alert>
                        </Stack>
                    }
                </div>
            </div>            
        </div>
    </>
    )
}

export default connect
(
    (state:any) => ({
        loading: state.presupuestos.loading,
        success: state.clientes.success
    }),
    dispatch => ({
        requestClienteContact: (data:any) => dispatch(requestClienteContact(data)),
    })
)(ContactForm);